import { css } from 'styled-components';

const breakpoints = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200
};

export const xs = (...styles) => css`
  @media (min-width: 0) {
    ${css(...styles)};
  }
`;

export const sm = (...styles) => css`
  @media (min-width: ${breakpoints.xs}) {
    ${css(...styles)};
  }
`;

export const md = (...styles) => css`
  @media (min-width: ${breakpoints.sm}) {
    ${css(...styles)};
  }
`;

export const lg = (...styles) => css`
  @media (min-width: ${breakpoints.md}) {
    ${css(...styles)};
  }
`;

export const xl = (...styles) => css`
  @media (min-width: ${breakpoints.lg}) {
    ${css(...styles)};
  }
`;

export const extractShorthand = (width) => {
  if (width) {
    if (typeof width === 'object') {
      return width;
    }

    return {
      xs: width
    };
  }

  return undefined;
};

export const explicitlyDefineScreenBrackets = (component) => {
  const width = extractShorthand(component.width);
  if (width) {
    return {
      ...component,
      width: {
        xl: width.xl || width.lg || width.md || width.sm || width.xs || 12,
        lg: width.lg || width.md || width.sm || width.xs || 12,
        md: width.md || width.sm || width.xs || 12,
        sm: width.sm || width.xs || 12,
        xs: width.xs || 12
      }
    };
  }

  return {
    ...component,
    width: {}
  };
};
